import NglObject from './NglObject.js'

function NglStore () {
  this.stage = ''

  this.objects = [this.makeObject('all', 'all', [], [])]

  this.labelSettings = {
    atom: {
      format: '%(atomname)s',
      sele: 'all'
    },
    residue: {
      format: '%(resname)s-%(chainname)s%(resno)s',
      sele: '.CA or .C4\''
    }
  }

  this.representationTypes = ['ball+stick', 'cartoon', 'licorice', 'backbone', 'point', 'surface']
}

NglStore.prototype = {
  get all () {
    return this.objects.find(obj => obj.type === 'all')
  },

  get sele () {
    return this.objects.find(obj => obj.name === 'sele')
  },

  get objectNames () {
    return this.objects.map(obj => obj.name)
  },

  get objectMap () {
    let m = new Map()
    this.objects.forEach((obj, i) => {
      if (obj.type === 'structure-component') {
        m.set(obj.components[0], i)
      }
    })
    return m
  },

  get structureObjects () {
    return this.objects.filter(obj => obj.type === 'structure-component')
  },

  get distanceObjects () {
    return this.objects.filter(obj => obj.type === 'distance')
  },

  get selectionObjects () {
    return this.objects.filter(obj => obj.type === 'selection')
  },

  get currentSelection () {
    return this.selectionObjects.find(obj => obj.visible)
  },

  get labelTypes () {
    return Object.keys(this.labelSettings)
  }
}

NglStore.prototype.updateObjectName = function (ind) {
  return ''
}

NglStore.prototype.getObjectByComponent = function (comp) {
  return this.structureObjects.find(obj => obj.components[0] === comp)
}

NglStore.prototype.getObjectById = function (id) {
  return this.objects.find(obj => obj.id === id)
}

NglStore.prototype.getObjectByName = function (name) {
  return this.objects.find(obj => obj.name === name)
}

NglStore.prototype.makeObject = function () {
  return new NglObject(this, ...arguments)
}

NglStore.prototype.addObject = function () {
  let obj = this.makeObject.apply(this, arguments)
  this.objects.push(obj)
  if (obj.type === 'selection') {
    obj.visible = false
    obj.updateSelection()
  }
  return obj
}

NglStore.prototype.deleteObjectById = function (id) {
  let v = this
  let obj = this.getObjectById(id)
  if (obj.type === 'all') {
    obj.components.forEach(comp => {
      v.stage.removeComponent(comp)
    })
    this.objects = this.objects.filter(obj => obj.type === 'all')
  } else if (obj.type === 'structure-component') {
    obj.components.forEach(comp => {
      v.stage.removeComponent(comp)
    })
    this.objects = this.objects.filter(obj => obj.id !== id)
  } else if (obj.type === 'selection') {
    // do nothing
  }
}

NglStore.prototype.deleteObjectByName = function (name) {
  this.deleteObjectById(this.getObjectByName(name).id)
}

export default NglStore
